//decori images -- patters --combinations
import esagono from './images/DecoriPage/patterns/esagono.svg'
import herringBone from './images/DecoriPage/patterns/herringBone.svg'
import largeChalet from './images/DecoriPage/patterns/largeChalet.svg'
import smallChalet from './images/DecoriPage/patterns/smallChalet.svg'
import appBg from './images/HomePage/cera_bg.mp4'
// decori pattern images
import patternHerringBone from './images/DecoriPage/images/herringBonePattern.png'
import patternEsagono from './images/DecoriPage/images/EsagonoPattern.png'
import patternChaletPiccolo from './images/DecoriPage/images/chaletPiccoloPattern.png'
import patternChaletGrande from './images/DecoriPage/images/chaletGrandePattern.png'
// ispirazione page images
import ispirazionePageFirstImage from './images/IspirazionePage/image.png'
import ispirazionePageSecondImage from './images/IspirazionePage/image2.png'
//Homepage bg
import homePageVideo from './images/HomePage/cera_hero.mp4'
// caratteristiche page images
import caratteristichePageFirstImage from './images/CaratteristichePage/first.png'
import caratteristichePageSecondImage from './images/CaratteristichePage/second.png'
import caratteristichePageThirdImage from './images/CaratteristichePage/third.png'

export const appConfig = {
    bg: appBg
}
export const ContactsPageConfig = {
	label: 'Contact Us',
	slug: '#contact_us',
}


export const ScagliePageConfig = {
  intro: 'Scaglie',
  titolo: 'Dynamism and balance',
zoom: 'Double-click to enlarge',
  explore: 'Drag the cursor to explore',
  descrizione: 'The Scaglie graphic, available in both Cerasilk and Matt-Pro finishes, is ideal for both flooring and wall cladding. <strong>Small wax fragments in shades of Smoke, Incense, or in the Multicolor variant</strong> spread over the Light background, giving the product a sense of complexity and a delicately rhythmic image.',
  images: [
    { label: 'Fumo' },
    { label: 'Multicolore'},
    { label: 'Incenso' },
  ],
formati: {
    titolo: 'Available in sizes',
  }
}
  
  
export const HomePageConfig = {
    MenuSideBarElements: [
        'START',
        'INSPIRATION',
        'CERASILK FINISH',
        'DETAILS AND DEPTH',
        'SCAGLIE',
        'GALLERY',
        'COLOURS AND SIZES',
        'COLLECTION',
        'CONTACT US'
    ],
	id:'start',
    title: 'Cera',
    secondary: 'UNEXPECTED SOFTNESS',
    videoUrl: homePageVideo,
    videoUrlMobile: homePageVideo,
    navbar: {
        btnColor: 'white',
        btnBackground: '#7A1C30'
    },
}
export const DetailsPageConfig = {
	id:'details_and_depth',
	key: 'depth',
	intro: 'DEPTH',
	title: 'Delve into the heart of the material',
	description: 'So soft and smooth, the surface surprises the eye with <strong>intense three-dimensionality</strong>. Let yourself be enveloped by the depth of the material, revealing gradations, transparencies, and different densities, echoing the patterns of melted wax.',
	ctaLabel: 'Discover Scaglie',
	key2: 'details',
	intro2: 'Details',
	title2: 'A fusion of elements',
	description2:'<p>It is up close that the richness of the details and chromatic variations is revealed. Every detail narrates Cera&#39;s creative process, from the randomness of its pouring to the moment when solid wax fragments crystallize within the material.</p><p><strong>The flakes sink into the liquid material, stopping at different levels</strong>, and harmoniously interact with the background, <strong>creating a graphic ensemble</strong> that is always new.</p>',
	ctaLabel2: 'Discover all the depth',
}

export const GalleryPageConfig = {
	intro:'Gallery',
	title:'Explore the possibilities of the wax effect',
	item1:'Plays of light and depth create unique environments.',
	item2:'Light and dark shades enrich the surface with movement, depth, and personality.', 
	item3:'A novel style for a contemporary and refined atmosphere',
	item4:'Richness of details and delicate nuances dance with extreme naturalness.',
	item5:'A surface with strong depth that conveys a total sensation of lightness.',
	item6:'A surface dedicated to those seeking an original and recognisable rendering',
	item7:'An aesthetic effect impossible to reproduce with other materials or finishes',
	item8:'The soft, matt finish gently reflects the light',
	item9:'The fast solidification in the creative process produced cracks and small cavities',
	item10:'The light and dark shadows recall the thickening of melted wax in some spots',
	item11:'Contemporary style for a timeless atmosphere',
}

export const FinishPageConfig = {
	id:'cerasilk_finish',
	intro:'CERASILK FINISH',
	title:'Feel the softness',
	description:'<p>Dense, soft and veiled.</p><p><span>Thanks to <strong>continuous research</strong> and experimentation, the <strong>Soft finish</strong> reproduces all the</span> <span>perceptive richness of the material from which it takes its inspiration, involving not only</span> <span>sight but also touch. Here porcelain stoneware finds a new expression, </span> <span>becoming <strong>incredibly silky</strong> to the touch</span>.</p>',
}

export const IspirazionePageConfig = {
	id:'inspiration',
	subtitle:'Inspiration',
	title:'Surprising suggestions',
    images: {
        first: ispirazionePageFirstImage,
        second: ispirazionePageSecondImage
    },
	
	description:'<p>The Cera collection is a <strong>sensory experience</strong>.</p><p>A novel effect that reinterprets classic porcelain stoneware, giving rooms the <strong>soft warmth of wax</strong> and the <strong>unpredictable graphic pattern</strong> where the element crystallises after casting.</p>',
	videoId:'936595560',
    content: {
        first: "Il gusto pregiato della tradizione",
        second: ['Cortina è  come un viaggio, ispirato al legno di recupero da', ' antiche baite alpine', ' sapientemente rilavorato nel rispetto naturale delle sue ', 'diverse essenze.'],
        third: ['Un percorso inedito, dove l’', 'esperienza catartica', ' della natura incontra la', ' forte personalità', ' estetica contemporanea.']
    },
    pageOffsetFromTopDesktop: '-150px', // to keep all the content in the top, not interfering with the navbar
    pageOffsetFromTopMobile: '-50px', // the mobile version, the lower the value the lower it will animate
    firstPhotoOffsetAnim: '250px', // this controls when should the photo animate when it is in viewport
    firstPhotoOffsetMobile: '400px', // same as above but for mobile
    primaryTextOffset: '200px', // the lower the value, the higher it will animate depending on the viewport
    primaryTextOffsetMobile: '200px',
    subTextOffset: '400px',
    subTextOffsetMobile: '150px',
    secondPhotoOffset: '200px',
    secondPhotoOffsetMobile: '300px'
}

export const ProcessoPageConfig = {
    content: {
        primary: ['La ricerca di un', 'equilibrio autentico'],
        secondary: ['', 'Un mix energico e bilanciato', ', nato dalla collaborazione con una prestigiosa falegnameria del bellunese, specializzata nel recupero di legnami antichi per esclusivi ambienti di lusso. Della ', 'sapienza artigiana alpina', ',  Cortina reinterpreta la ricerca e selezione delle doghe migliori di legni diversi, dando vita a un raffinato equilibrio di essenze. ', 'Per una superficie difficilmente replicabile.']
    },
    video: {
        id: '581728609'
    },
    primaryTextOffset: '300px',
    primaryTextOffsetMobile: '200px',
    subTextOffset: '300px',
    subTextOffsetMobile: '300px'
}

export const ColoriFormatiPageConfig = {
	id:'colours_and_sizes',
	intro:'COLOURS AND SIZES',
	title:'To every style its expression',
	item1:'Bright, pure, almost ethereal. It gives a cosy feeling of lightness.',
	item2:'It fills spaces with velvety warmth for a harmonious aesthetic effect.',
	item3:'A refined tone that enhances the depth of the graphic patterns and the strong identity of the design.',
	disponibile:'Available in sizes',
	scopri:'Discover the sizes',
	description: '<p><span><strong>Three neutral colours</strong>, enriched with distinctive features and details, balancing the choice between warm and cold tones, purity and personality, <strong>to suit every sensation</strong> with the same softness and flexibility of wax.</span></p>',
    content: {
        primary: 'Più colori per ogni formato',
        secondary: ['Almond, Honey, Natural e Tobacco esaltano la varietà e la ricchezza naturale del legno con', ' tonalità inedite', ', più moderne e versatili. Ogni colore è reso unico dall’esclusiva', ' stonalizzazione cromatica e grafica', ', creando avvolgenti giochi di contrasto e pregiati intrecci lignei.']
    },
    primaryTextOffset: '150px',
    primaryTextOffsetMobile: '300px',
    subTextOffset: '300px',
    subTextOffsetMobile: '300px'
}

export const CaratteristichePageConfig = {
    firstContainer: {
        image: caratteristichePageFirstImage,
        content: {
            primary: 'Quando i particolari diventano protagonisti',
            secondary: [' Ti sei mai fermato a osservare tutte le ', 'venature del grès porcellanato', '? In Cortina le più marcate del tenero legno di abete seguono quelle fitte del larice per incontrare i nodi e le cromie tipiche del pino.'],
            tertiary: ['Le ', 'sfumature uniche e irripetibili', ' di ogni lastra Cortina raccontano la provenienza ormai così rara e preziosa delle doghe originali, colorate da Sole e pioggia in oltre 40-70 anni di posa fra baite e antichi fienili.']
        },
        imageOffset: '300px',
        imageOffsetMobile: '700px',
        primaryTextOffset: '350px',
        primaryTextOffsetMobile: '300px',
        subTextOffset: '400px',
        subTextOffsetMobile: '350px'
    },
    secondContainer: {
        image: caratteristichePageSecondImage,
        content: {
            primary: 'L’armonia tra struttura e segni artigianali',
            secondary: ['Calore e struttura esaltano la ', 'potenza materica', ' di Cortina, dal grande impatto visivo e così piacevole e naturale al tatto. Un’esperienza autentica da toccare con mano.'],
            tertiary: ['Ripercorri le ', 'venature del legno', ', arricchite dai ', 'segni artigianali del taglio sega', ': incisioni irregolari che richiamano le antiche lavorazioni della falegnameria tradizionale. ']
        },
        imageOffset: '300px',
        imageOffsetMobile: '500px',
        primaryTextOffset: '300px',
        primaryTextOffsetMobile: '250px',
        subTextOffset: '350px',
        subTextOffsetMobile: '300px'
    },
    thirdContainer: {
        image: caratteristichePageThirdImage,
        content: {
            primary: 'Molto più di un’estetica ricercata',
            secondary: ['Una collezione in cui l’', 'eleganza del legno ', 'non rinuncia alla ', 'resistenza senza tempo ', 'del grès porcellanato, portando la sua atmosfera confortevole anche in ambienti esposti a forte usura e calpestio.'],
            tertiary: ['Una finitura dal ', 'gusto ecosostenibile', ', dove la ricercatezza si traduce in attenzione all’ambiente, fondendo etica ed estetica per rendere disponibile un prodotto raro, dalla resa non ottenibile con materiali naturali.']
        },
        imageOffset: '300px',
        imageOffsetMobile: '450px',
        primaryTextOffset: '250px',
        primaryTextOffsetMobile: '200px',
        subTextOffset: '300px',
        subTextOffsetMobile: '250px'
    }
}

export const DecoriPageConfig = {
    content: {
        primary: 'Quattro decori. Infinite possibilità.',
        secondary: ['Dai un tocco in più ai tuoi ambienti con i decori. Volumi e linee geometriche disegnano uno stile dal forte impatto visivo. Listelli, esagoni o spine di pesce: ogni decoro è disponibile in tutti i colori della collezione per creare atmosfere e sensazioni diverse.']
    },
    mobileContent: {
        primary: 'I quattro decori di Cortina',
        secondary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    patterns: [
        {
            name: 'Chalet',
            firstDimension: '15x90 cm',
            secondDimension: '6"x36"',
            src: largeChalet,
            content: 'Il calore di un ambiente che diventa rifugio accogliente. L’eleganza rigenerante degli elementi naturali si ispira al fascino degli chalet: la tradizionale grafica mossa riempie gli interni di charm.'
        
            },
        {
            name: 'Chalet',
            firstDimension: '12x75 cm',
            secondDimension: '5"x30"',
            src: smallChalet,
            content: 'Un formato più piccolo per un effetto ancora più dinamico, in grado di portare la viva espressività degli elementi naturali fra le pareti di una stanza,  trasformandola.'
        },        
        {
            name: 'Esagono',
            firstDimension: '25x21,6 cm',
            secondDimension: '10"x8<sup>1/2</sup>"',
            src: esagono,
            content: 'La bellezza inconsueta dei giochi geometrici. Il decoro Esagono dona al calore tipico del legno un sorprendente gusto internazionale e moderno. Per un’atmosfera di precisa originalità.'
        },
        {
            name: 'Herringbone',
            firstDimension: '36,2x41x2 cm',
            secondDimension: '14<sup>1/8</sup>"x16<sup>1/8</sup>"',
            src: herringBone,
            content: 'La tradizione italiana trova nuova espressione. Herringbone trasforma il tipico pavimento a doghe piccole e diagonali in un decoro versatile, che esalta la combinazione di essenze e porta il suo fascino dinamico anche a rivestimento.'
        },
        
        
    ],
    patternImages: [
        patternChaletGrande,
        patternChaletPiccolo,
        patternEsagono,
        patternHerringBone,      
        
    ],
    primaryTextOffset: '450px',
    primaryTextOffsetMobile: '100px',
    subTextOffset: '500px',
    subTextOffsetMobile: '100px'
}

export const FormConfiguration = {
    paesi: [
        'Italia',
        'Albania',
        'Germany',
        'France',
        'Inghilterra'
    ],
    citta: [
        'Milano',
        'Torino',
        'Roma',
        'Napoli'
    ],
    cap: [
        '20100',
        '12838',
        '123123',
        '1231212'
    ],
    infoSulPrivacy: 'http://wikipedia.it'
}

export const FooterLinks = {
    sedeLegale: '/location',
    showroom: '/location'
}

export const SocialLinks = {
    facebook: 'https://facebook.com',
    linkedin: 'linkedin.com',
    twitter: 'twitter.com',
    instagram: 'instagram.com',
    pinterest: 'pinterest.com',
    youtube: 'youtube.com'
}

export const CollezioniPageConfig = {
    videoId: '936596731',
	id:'collection',
	title: 'The Collection'
}
